import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ConvenienceStoreIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ConvenienceStoreIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.0375 9.39209L22.0343 9.38312L22.0334 9.38085L20.4708 5.47438C20.3815 5.25131 20.1655 5.10503 19.9252 5.10503H18.3581V2.55859C18.3581 2.23406 18.095 1.97095 17.7705 1.97095H6.40946C6.08493 1.97095 5.82182 2.23406 5.82182 2.55859V5.10503H4.25478C4.01447 5.10503 3.79842 5.25131 3.70918 5.47442L2.14661 9.38085L2.14571 9.38312L2.14218 9.39197C2.11511 9.45951 2.1001 9.53308 2.1001 9.61026V10.4721C2.1001 11.3593 2.5708 12.1383 3.27538 12.5734V21.4414C3.27538 21.7659 3.53849 22.029 3.86302 22.029H20.3169C20.6414 22.029 20.9046 21.7659 20.9046 21.4414V12.5734C21.6091 12.1383 22.0798 11.3593 22.0798 10.4721V9.61026C22.0798 9.53308 22.0646 9.45963 22.0375 9.39209ZM6.9971 3.14622H17.1828V6.67206H6.9971V3.14622ZM4.65261 6.2803H5.82182V7.2597C5.82182 7.58423 6.08493 7.84734 6.40946 7.84734H17.7705C18.095 7.84734 18.3581 7.58423 18.3581 7.2597V6.2803H19.5273L20.6243 9.02262H3.55568L4.65261 6.2803ZM14.5581 10.1979H17.1437V10.4721C17.1437 11.185 16.5637 11.7649 15.8509 11.7649C15.138 11.7649 14.558 11.185 14.558 10.4721L14.5581 10.1979ZM10.7972 10.1979H13.3828V10.4721C13.3828 11.185 12.8028 11.7649 12.09 11.7649C11.3771 11.7649 10.7972 11.185 10.7972 10.4721L10.7972 10.1979ZM7.03628 10.1979H9.62189V10.4721C9.62189 11.185 9.04193 11.7649 8.32908 11.7649C7.61623 11.7649 7.03627 11.185 7.03627 10.4721L7.03628 10.1979ZM3.27539 10.4721V10.1979H5.861V10.4721C5.861 11.185 5.28104 11.7649 4.56819 11.7649C3.85534 11.7649 3.27539 11.185 3.27539 10.4721ZM6.80123 20.8538V15.3691H10.3271V20.8538H6.80123ZM19.7293 20.8538H11.5023V14.7815C11.5023 14.457 11.2392 14.1938 10.9147 14.1938H6.21359C5.88906 14.1938 5.62595 14.457 5.62595 14.7815V20.8538H4.45067V12.9372C4.48965 12.9391 4.52879 12.9402 4.5682 12.9402C5.32093 12.9402 5.99558 12.6011 6.44865 12.0681C6.90172 12.6011 7.57637 12.9402 8.3291 12.9402C9.08183 12.9402 9.75648 12.6011 10.2095 12.0681C10.6626 12.6011 11.3373 12.9402 12.09 12.9402C12.8427 12.9402 13.5174 12.6011 13.9704 12.0681C14.4235 12.6011 15.0982 12.9402 15.8509 12.9402C16.6036 12.9402 17.2783 12.6011 17.7313 12.0681C18.1844 12.6011 18.8591 12.9402 19.6118 12.9402C19.6512 12.9402 19.6903 12.9391 19.7293 12.9372L19.7293 20.8538ZM20.9046 10.4721C20.9046 11.185 20.3246 11.7649 19.6118 11.7649C18.8989 11.7649 18.319 11.185 18.319 10.4721V10.1979H20.9046L20.9046 10.4721Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.76001 5.49678H15.4199C15.7444 5.49678 16.0076 5.23367 16.0076 4.90914C16.0076 4.58461 15.7444 4.3215 15.4199 4.3215H8.76001C8.43548 4.3215 8.17237 4.58461 8.17237 4.90914C8.17237 5.23367 8.43548 5.49678 8.76001 5.49678Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9664 14.1938H13.2652C12.9407 14.1938 12.6776 14.4569 12.6776 14.7815V18.3073C12.6776 18.6318 12.9407 18.895 13.2652 18.895H17.9664C18.2909 18.895 18.554 18.6318 18.554 18.3073V14.7815C18.554 14.4569 18.2909 14.1938 17.9664 14.1938ZM17.3787 17.7197H13.8529V15.3691H17.3787V17.7197Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.95589 16.9362C8.63136 16.9362 8.36825 17.1993 8.36825 17.5238V18.3073C8.36825 18.6318 8.63136 18.895 8.95589 18.895C9.28042 18.895 9.54353 18.6318 9.54353 18.3073V17.5238C9.54353 17.1993 9.28042 16.9362 8.95589 16.9362Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ConvenienceStoreIcon;
